import { MIN_PASSWORD_LENGTH } from '@palacete/shared/password-policy';

export type PasswordStrength = { score: 0 | 1 | 2 | 3; label: string };

// Heurística simple (no reglas de complejidad obligatorias, solo feedback en vivo):
// puntúa por longitud y variedad de tipos de carácter. Reusada por PasswordField.
export function passwordStrength(password: string): PasswordStrength {
  if (!password) return { score: 0, label: '' };
  let points = 0;
  if (password.length >= MIN_PASSWORD_LENGTH) points++;
  if (password.length >= 12) points++;
  const varieties = [/[a-z]/, /[A-Z]/, /[0-9]/, /[^a-zA-Z0-9]/].filter((re) => re.test(password)).length;
  if (varieties >= 3) points++;

  if (points <= 1) return { score: 1, label: 'Débil' };
  if (points === 2) return { score: 2, label: 'Aceptable' };
  return { score: 3, label: 'Fuerte' };
}
